import { useEffect } from "react"

import { useScrollActions } from "features/scroll-management/model/store/useScrollActions"

export function usePreventWindowScroll({
  id,
  isScrollDisabled
}: {
  id: string
  isScrollDisabled: boolean
}) {
  const { preventScroll, allowScroll } = useScrollActions()

  useEffect(() => {
    if (isScrollDisabled) {
      preventScroll({ id })
    } else {
      allowScroll({ id })
    }
    return () => {
      allowScroll({ id })
    }
  }, [isScrollDisabled])
}
